import { a } from "../utils";
import { Location } from "../../models/Location";

export const setMyLocations = (locations: Location[]) =>
    a({ type: "SET_LOCATIONS", locations });
